import React, 
       { useEffect, 
         useState,
         useContext }               from 'react';
import { Container, 
         Row, 
         Col}                       from 'react-bootstrap';
import { useLocation }              from 'react-router-dom';
import { AuthContext }              from './AuthContext';
import api                          from './AxiosConfig';
import GoalDetailsUpdate            from './GoalDetailsUpdate';
import LoggedOutCard                from './LoggedOutCard';

function EditGoal() {
  const location                     = useLocation(); // Hook to access location and state 
  const selectedId                   = location.state.id || {}; // Destructure state and handle undefined
  const [ goal, setGoal ]            = useState();
  const [ refresh, setRefresh]       = useState( true );
  const { isLoggedIn, checkSession } = useContext(AuthContext);

  useEffect(() => {
    const callCheckSession = async () => {
        try {
            await checkSession();
        } catch (error) {
            console.log("Error calling checkSession." + error.message);
        }
    }
    callCheckSession();
  } );

  useEffect(() => {
      async function getGoal() {
          if ( selectedId && refresh) {
              try {
                  const response = await api.get(`/site/goals/${encodeURIComponent(selectedId)}`, {withCredentials: true });
                  setGoal(response.data);
                  setRefresh( false );
              } catch (error) {
                  console.log("updateGoal: " + error);
              }
          }
      }
      // Fetch the detailed record for this goal.
      getGoal();
  }, [selectedId, refresh]); 


  const requestRefresh = () => {
      setRefresh( true );
  }
       
  return (
    <>{ isLoggedIn ? (
    <div className="container mt-5">
       {selectedId ? (
        <>
        <Container>
           <Row>
               <Col xs={12} sm={12} md={6} lg={6}><GoalDetailsUpdate  selGoal={goal} refresh={requestRefresh}/></Col>
           </Row>
        </Container>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div> ) : ( <LoggedOutCard /> ) }
    </>
  );
}

export default EditGoal;
